import { Analyse } from 'src/app/domain/Analyse/analyse';
import { Taxon } from 'src/app/domain/Analyse/taxon';

export class TaxonDialogModel {

    Taxon: Taxon = new Taxon();
    Analyse: Analyse = new Analyse();

    // IBMR ONLY
    ProcessCode: string;
    LastSelectedPhase: number;
    AlreadyPickedPhase: number[] = [];
}
